module.exports = __webpack_public_path__ + "img/bus.82d827cc.svg";